export function createBgLinkStrFunction(imageLink: string): string {
    return `url("${imageLink}")`;
}
